import React from 'react';
interface MobileInfoRowProps {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}
export function MobileInfoRow({
  label,
  value,
  mono
}: MobileInfoRowProps) {
  return <div className="flex items-start justify-between gap-3 border-b border-slate-100 py-2.5 last:border-0" data-id="element-210" data-mp="1vcrrxhl8rvvh">
      <dt className="shrink-0 text-[13px] text-slate-500" data-id="element-211" data-mp="1zdlfuayopaod">{label}</dt>
      <dd className={`text-right text-[13px] font-semibold text-navy-900 ${mono ? 'font-mono text-xs' : ''}`} data-id="element-212" data-mp="1zbqqmkgdqweh">{value}</dd>
    </div>;
}